export class FileUpload {
    id: string;
    name: string;
    url: string;
    type: string;
    path: string;
    realName: string;
    img?: string;
    origin?: string;
    filePath?: string;
    fileName?: string;
    constructor(
        id: string,
        name: string,
        url: string,
        type: string,
        path: string,
        realName: string
    ) {
        this.id = id;
        this.name = name;
        this.url = url;
        this.type = type;
        this.path = path;
        this.realName = realName;
    }
}
